import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { TRIAL_BANNER_HEIGHT } from "app/components/React/TrialBanner/StyledTrialBanner";
import { AI_AGENT_GMAIL_KB_ARTICLE_LINK } from "app/pages/sales-intelligence/constants/common";
import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { AIAgentCaption } from "app/pages/sales-intelligence/modules/ai-agent/components/AIAgentCaption";
import { AgentKnowledgeBase } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/AgentKnowledgeBase";
import DataCreditsIndicatorContainer from "app/pages/sales-intelligence/modules/quota/containers/DataCreditsIndicatorContainer/DataCreditsIndicatorContainer";
import { AIAgentMainErrorView } from "app/pages/sales-intelligence/pages/ai-agent/components/AIAgentMainErrorView/AIAgentMainErrorView";
import { GmailActionButton } from "app/pages/sales-intelligence/pages/ai-agent/components/GmailActionButton/GmailActionButton";
import { AIAgentEmailPageContent } from "app/pages/sales-intelligence/pages/ai-agent/containers/AIAgentEmailPageContent/AIAgentEmailPageContent";
import { isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

import { StyledEmailHeaderButtonsWrapper } from "./styles";

const AIAgentEmailPageContainer = () => {
    const isTrialBannerVisible = isTrialOrAfterTrial();
    const topOffset = isTrialBannerVisible ? TRIAL_BANNER_HEIGHT : 0;
    return (
        <Stack
            alignItems="center"
            minHeight={isTrialBannerVisible ? `calc(100vh - ${TRIAL_BANNER_HEIGHT}px)` : "100vh"}
            width="100%"
            alignSelf="center"
            padding="24px 24px 0"
            maxWidth="1243px"
        >
            <Text
                display="flex"
                alignItems="center"
                gap="16px"
                fontVariant="h2"
                color={colorsPalettes.carbon[500]}
                width="100%"
                data-automation="page-title"
            >
                {translate("primary.sidebar.salesIntelligence.email")}
                <Badge type="beta" />
            </Text>
            <StyledEmailHeaderButtonsWrapper top={topOffset + 26}>
                <DataCreditsIndicatorContainer />
                <GmailActionButton />
                <AgentKnowledgeBase
                    top={0}
                    helpLinkHref={AI_AGENT_GMAIL_KB_ARTICLE_LINK}
                />
            </StyledEmailHeaderButtonsWrapper>
            <Stack
                flex="1"
                padding="24px 0"
                width="100%"
                maxHeight="100%"
                overflow="hidden"
                gap="24px"
            >
                <ErrorBoundaryWithLogging FallbackComponent={AIAgentMainErrorView}>
                    <AIAgentEmailPageContent />
                </ErrorBoundaryWithLogging>
            </Stack>
            <AIAgentCaption />
        </Stack>
    );
};

export default AIAgentEmailPageContainer;
